module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0132.jpg?v=e7cec396";